import React from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const PricingCard = ({ plan }) => {
    return (
        <div 
            className={`rounded-2xl p-8 shadow-xl ${
                plan.isPopular 
                    ? 'bg-primary text-white border-2 border-primary/20' 
                    : 'bg-gray-900 text-gray-300'
            }`}
        >
            <div className="text-center mb-8">
                <h3 className="text-2xl font-bold mb-2">{plan.name}</h3>
                <div className="text-3xl font-bold mb-1">{plan.price}</div>
                <div className="text-sm opacity-80">{plan.period}</div>
                <p className="mt-4 text-sm opacity-80">{plan.description}</p>
            </div>
            <ul className="space-y-4">
                {Object.entries(plan.features).map(([feature, isIncluded], featureIndex) => (
                    <li 
                        key={featureIndex} 
                        className="flex items-start space-x-3 pb-4 border-b border-gray-700 last:border-b-0"
                    >
                        {isIncluded ? (
                            <FaCheck className="w-5 h-5 mt-1 flex-shrink-0 text-green-500" />
                        ) : (
                            <FaTimes className="w-5 h-5 mt-1 flex-shrink-0 text-red-500" />
                        )}
                        <span className={!isIncluded ? 'opacity-50' : ''}>
                            {feature}
                        </span>
                    </li>
                ))}
            </ul>
            <div className="mt-8 text-center">
                <Link 
                    to="/membership"
                    className={`inline-block w-full py-3 px-6 rounded-full font-medium transition-colors duration-200 ${
                        plan.isPopular 
                            ? 'bg-white text-primary hover:bg-gray-100' 
                            : 'bg-primary text-white hover:bg-primary-dark'
                    }`}
                >
                    View Membership Plans
                </Link>
            </div>
        </div>
    );
};

export default PricingCard; 